var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "courseList" },
    _vm._l(_vm.leftTree, function(item, index) {
      return _c(
        "div",
        {
          key: index,
          class: ["courseItem", { cur: _vm.curId == item.id }],
          attrs: { title: item.courseName || item.name },
          on: {
            click: function($event) {
              return _vm.treeClick(item.id)
            }
          }
        },
        [_vm._v("\n    " + _vm._s(item.courseName || item.name) + "\n  ")]
      )
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0d214171", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0d214171","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/szrt_revision/components/standardProduct.vue
// module id = null
// module chunks = 